import React, { useEffect, useState } from 'react';
import { financialAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { fmtDate } from '../utils/date';
import BackButton from '../components/BackButton';

export default function ProfitDetail() {
  const { business } = useAuth();
  const [summary,   setSummary]   = useState(null);
  const [sold,      setSold]      = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    Promise.all([
      financialAPI.summary(),
      financialAPI.detail('cogs'),
    ]).then(([sumRes, cogsRes]) => {
      setSummary(sumRes.data.summary);
      setSold(cogsRes.data.rows || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const fmt = (n) => new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);
  const cur = business?.currency;
  const profit = Number(summary?.gross_profit || 0);

  if (loading) return <div className="page"><p className="text-muted">Loading…</p></div>;

  return (
    <div className="page">
      <BackButton />
      <h1 className="page-title">Gross Profit</h1>

      {/* Summary strip */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.5rem', marginBottom: '1.5rem' }}>
        {[
          { label: 'Revenue',      value: summary?.revenue,    color: 'var(--color-text)' },
          { label: 'Cost (COGS)',  value: summary?.cogs,       color: '#ef4444' },
          { label: 'Gross Profit', value: profit,              color: profit >= 0 ? '#22c55e' : '#ef4444' },
        ].map(({ label, value, color }) => (
          <div key={label} className="card" style={{ textAlign: 'center' }}>
            <div className="text-muted" style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.3rem' }}>{label}</div>
            <div style={{ fontWeight: 700, fontSize: '0.95rem', color }}>{cur} {fmt(value)}</div>
          </div>
        ))}
      </div>

      {/* Cost of goods list — what was SOLD, each at its cost when it was sold */}
      <h2 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.75rem' }}>
        Cost of goods sold
      </h2>

      {sold.length === 0 && <p className="text-muted">No sales recorded yet.</p>}

      {sold.map(p => (
        <div key={p.id} className="card" style={{ marginBottom: '0.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>{p.product_name}</div>
              <div className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.15rem' }}>
                Sold {fmtDate(p.sold_at)} · Qty {Number(p.qty)} · {cur} {fmt(p.unit_cost)}/unit cost
              </div>
            </div>
            <div style={{ fontWeight: 700, flexShrink: 0, marginLeft: '0.75rem' }}>
              {cur} {fmt(p.total_cost)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
